import React from 'react';
import { Container } from 'react-bootstrap';
import SubNav from '../../components/SubNav.js'; 

const Regional = () => {

  return (
    <Container className="mt-4">
      {/* Main content here */}
    </Container>
  );
};

export default Regional;
